/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-console */
/* eslint-disable import/no-named-as-default */

import Text from "@components/CustomText";
import SearchIcon from "@assets/svg/SearchIcon";
import React, { memo, useCallback, useRef, useMemo } from "react";
import {
  Alert,
  StyleSheet,
  TouchableWithoutFeedback,
  View,
  FlatList,
  ActivityIndicator,
  Modal,
  TouchableOpacity,
  Linking,
  Dimensions,
} from "react-native";
import { debounce } from "lodash";
import color from "@constants/color";
import { fontFamily } from "@utils/styles";
import Button from "@components/Button";
import OutlineTag from "@components/Tag";
import DownArrowSmall from "@assets/svg/DownArrowSmall";
import CallIcon from "@assets/svg/newCall";
import DbScooter from "@assets/svg/CpDeliveryBoys/db_scooter";
import handleCallButtonPress from "@utils/handleCallButtonPress";
import { CP_DB_EVENTS } from "@constants/analyticsEventsCT";
import HeaderWithSearch from "@components/SearchHeader/HeaderWithSearch";
import UpdateAppModal from "@components/UpdateAppModal";
import t from "@constants/localization";
import { useFocusEffect } from "@react-navigation/native";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "@reducers/cpDeliveryRoutesReducer";
import SwitchDbConfirmationModal from "./SwitchDbConfirmationModal";
import getDbsForFilters from "./getDbsForFilters";
import {
  cardDraftKey,
  getRouteListSorted,
  isDisabledCard,
  isMultiTripCp,
  isTripCard,
  tripCardLabel,
} from "./cardHelpers";

const ALL_FILTER = {
  route_id: "ALL",
  route_name: "ALL",
  db_name: "ALL",
  db_id: "",
};

const CpDeliveryRoutes = ({ navigation, route }) => {
  const dispatch = useDispatch();

  // Use selector to get state from the reducer
  const {
    routes,
    filteredRoutes,
    selectedRouteId,
    switchDbId,
    loading,
    draftRoutes,
    expandedState,
    showSwitchDbConfirmModal,
    isCurrentDeliveryTab,
    isSearchEnabled,
    error: fetchRoutesError,
  } = useSelector((state) => state.cpDeliveryRoutesReducer);

  const isUpdateAppRequired =
    fetchRoutesError?.response?.data?.error === "UPDATE_APP_FROM_PLAYSTORE";

  const isProcessingRef = useRef(false);

  const PATH = "screens/CpDeliveryRoutes/index";

  const allRoutes = useMemo(() => {
    const initialRoutes = [ALL_FILTER].concat(
      filteredRoutes?.active_routes || [],
    );
    return getDbsForFilters(initialRoutes, routes?.assigned_routes || []);
  }, [filteredRoutes?.active_routes, routes?.assigned_routes]);

  // Memoize the debounced search function to prevent recreation on every render
  const onSearchInputChange = useCallback(
    debounce((text) => {
      dispatch(actions.filterRoutesBySearch(text, routes));
    }, 500),
    [routes, dispatch],
  );

  // Handler for toggling search enabled state
  const setIsSearchEnabled = useCallback(
    (value) => {
      dispatch(actions.toggleSearchEnabled(value));
    },
    [dispatch],
  );

  useFocusEffect(
    useCallback(() => {
      dispatch(actions.fetchData("ALL", isCurrentDeliveryTab));
    }, [isCurrentDeliveryTab, dispatch]),
  );

  const onPressSelectRoute = useCallback(
    (routeId) => {
      dispatch(actions.selectRoute(routeId));
      dispatch(actions.fetchData(routeId, isCurrentDeliveryTab));
    },
    [dispatch, isCurrentDeliveryTab],
  );

  const onPressRoutePill = useCallback(
    ({ routeId, routeData, force }) => {
      // Locked trip card: only the chip for the route the trip is on is
      // rendered at all now (B-2/B-4, see getRouteListSorted), and tapping it
      // does nothing. Route change requires Unassign first (B-48-R). `force`
      // is the Unassign button's own path, which must still get through.
      //
      // B-2: this guard used to exempt routeId "UNASSIGN", which is why one of
      // the four greyed chips silently still worked. The exemption is gone —
      // the button passes force:true and never needed it.
      if (!force && isTripCard(routeData)) return;
      // A disabled card (presented orders, finished trip) is closed-out work:
      // its one remaining chip is a label, never a control.
      if (isDisabledCard(routeData)) return;

      const {
        delivery_date,
        cx_id,
        cx_address,
        cx_lat,
        cx_lng,
        order_id,
        order_edd,
      } = routeData;

      const key = cardDraftKey(routeData);
      const newDraftRoutes = { ...draftRoutes };

      if (newDraftRoutes[key] && newDraftRoutes[key].route_id === routeId) {
        delete newDraftRoutes[key];
      } else {
        newDraftRoutes[key] = {
          route_id: routeId,
          delivery_date,
          cx_id,
          cx_address,
          cx_lat,
          cx_lng,
          order_id,
          order_edd,
          // R-611 — the per-card Unassign hints, straight from the card the
          // backend emitted. Sent only for an Unassign, and only when the
          // backend actually decided them: on a flag-OFF response these are all
          // undefined and the payload is byte-identical to today's, which is
          // what keeps the legacy CX-level Unassign working unchanged.
          ...(routeId === "UNASSIGN" && routeData?.trip_card_id
            ? {
                // SCOPE, not decoration. The backend reads a MISSING value on
                // either of these as "widen", never as "nothing to do":
                //   - getMarkedOfdCxs(..., { db_id: tp.cp_db_id ?? null }) and
                //     cpDbOfdCx.js `and ($(db_id) is null or cp_db_id = $(db_id))`
                //     -> a null cp_db_id strips EVERY boy under the CP;
                //   - `requestedTripId = tp.unassign_trip_id ?? tp.trip_id ??
                //     tp.tripId` -> a null trip id applies NO trip filter and
                //     strips every live trip for the customer.
                // Paired with `cx_id` above, these three are what pin the
                // unassign to exactly this customer, this boy and this trip.
                cp_db_id: routeData.cp_db_id ?? null,
                unassign_strip_ofd: routeData.unassign_strip_ofd === true,
                unassign_keep_touchpoint:
                  routeData.unassign_keep_touchpoint === true,
                // Read BOTH card fields, `unassign_trip_id` first. The card
                // genuinely carries a trip id under either name -- cardHelpers
                // `tripCardLabel` already reads `trip_id ?? unassign_trip_id`
                // for the label, and the OFD Details screen's own unassign
                // builder reads `unassign_trip_id ?? trip_id`
                // (OutForDeliveryDetails/index.js:249-251). Taking only
                // `unassign_trip_id` made this the one place that could send
                // null while the card was holding a real trip id -- and null
                // here is the widen above, not a no-op. Same two-source read
                // on both screens now.
                unassign_trip_id:
                  routeData.unassign_trip_id ?? routeData.trip_id ?? null,
              }
            : {}),
        };
      }

      dispatch(actions.updateDraftRoutes(newDraftRoutes));
    },
    [draftRoutes, dispatch],
  );

  const onPressAssignCpTpsBulk = async () => {
    if (isProcessingRef.current) return;
    isProcessingRef.current = true;
    try {
      if (draftRoutes && Object.keys(draftRoutes).length > 0) {
        const data = Object.values(draftRoutes);
        dispatch(actions.assignTouchpointBulk(data, isCurrentDeliveryTab));
      }
    } catch (error) {
      console.log(error);
    } finally {
      isProcessingRef.current = false;
    }
  };

  const onPressExpandSwitchDb = () => {
    dispatch(actions.toggleExpandState());
  };

  const onPressSwitchDb = (dbID) => {
    dispatch(actions.setSwitchDbId(dbID));
    dispatch(actions.toggleSwitchDbConfirmModal(true));
  };

  const onCloseSwitchDbModal = () => {
    dispatch(actions.setSwitchDbId(null));
    dispatch(actions.toggleSwitchDbConfirmModal(false));
  };

  const transferAllDeliveries = async () => {
    if (switchDbId) {
      const payload = {
        db_id: switchDbId,
        route_id: filteredRoutes?.route_id,
      };

      dispatch(actions.updateDbRoute(payload));
    }
  };

  const isRouteHasDb = (routeId) => {
    const currentRoute = routes?.assigned_routes?.find(
      (r) => r.route_id === routeId,
    );
    return currentRoute?.db_id || false;
  };

  const callCustomer = (phoneNumber) => {
    handleCallButtonPress(phoneNumber, CP_DB_EVENTS.CUSTOMERS_CALLED);
  };

  const changeTab = (tab) => {
    dispatch(actions.setCurrentDeliveryTab(tab));
    dispatch(actions.fetchData(selectedRouteId, tab));
  };

  const renderRoute = useCallback(
    (routeData, key) => {
      const result = (
        <RouteContainer
          key={key}
          routeData={routeData}
          activeRoutes={filteredRoutes?.active_routes || []}
          draftRoutes={draftRoutes}
          onPressRoutePill={onPressRoutePill}
          callCustomer={callCustomer}
        />
      );
      return result;
    },
    [
      filteredRoutes?.active_routes,
      draftRoutes,
      onPressRoutePill,
      callCustomer,
    ],
  );

  return (
    <>
      <HeaderWithSearch
        headertitle={t(`${PATH}/headerTitle`)}
        headerColor="#fff"
        hideShadow={false}
        navigation={navigation}
        route={route}
        isSearchEnabled={isSearchEnabled}
        onSearchInputChange={onSearchInputChange}
        onPressCrossIcon={() => {
          setIsSearchEnabled(false);
          onSearchInputChange("");
        }}
        searchPlaceholder={t(`${PATH}/searchPlaceholder`)}
        rightComponent={
          <View style={{ flexDirection: "row" }}>
            <TouchableOpacity
              testID="search_enable"
              onPress={() => setIsSearchEnabled(true)}
            >
              <SearchIcon height={20} width={20} fill={color.black} />
            </TouchableOpacity>
          </View>
        }
      />
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          backgroundColor: color.white,
          alignItems: "center",
          elevation: 0,
        }}
      >
        <TabButton
          title={t(`${PATH}/currentDeliveries`)}
          isActive={isCurrentDeliveryTab}
          onPress={() => changeTab(true)}
        />
        <TabButton
          title={t(`${PATH}/upcomingDeliveries`)}
          isActive={!isCurrentDeliveryTab}
          onPress={() => changeTab(false)}
        />
      </View>

      <>
        <View>
          <FlatList
            horizontal
            data={allRoutes}
            keyExtractor={(item, index) => `route-${item.route_id || index}`}
            style={styles.filtersContainer}
            showsHorizontalScrollIndicator={false}
            renderItem={({ item, index: _index }) => (
              <TouchableWithoutFeedback
                onPress={() => onPressSelectRoute(item.route_id)}
              >
                <View
                  style={[
                    selectedRouteId === item?.route_id
                      ? styles.selectedFilter
                      : styles.filter,
                    { marginLeft: item?.route_id === "ALL" ? 16 : 4 },
                  ]}
                >
                  <View
                    style={{
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "flex-start",
                      maxWidth: 100,
                      marginRight: item?.route_id === "ALL" ? 0 : 15,
                    }}
                  >
                    <Text
                      variant="body_text_3"
                      numberOfLines={1}
                      style={
                        selectedRouteId === item?.route_id
                          ? styles.selectedText
                          : styles.notSelectedText
                      }
                    >
                      {`${item?.route_name || ""}`}
                    </Text>
                    {item?.route_id !== "ALL" &&
                      item?.route_id !== "MISROUTE" &&
                      item?.route_id !== "UNASSIGN" && (
                        <Text
                          variant="caption_3"
                          numberOfLines={1}
                          style={[
                            item?.db_id === null
                              ? { color: color.plain_red }
                              : selectedRouteId === item?.route_id
                                ? { color: "rgba(255, 255, 255, 0.56)" }
                                : { color: color.mediumBlacklightBlack },
                            { fontWeight: "400" },
                          ]}
                        >
                          {`${item?.db_name || "No Delivery Boy"}`}
                        </Text>
                      )}
                  </View>
                  {item?.route_id !== "ALL" && (
                    <Text
                      variant="title_16"
                      style={
                        selectedRouteId === item?.route_id
                          ? styles.selectedText
                          : styles.notSelectedText
                      }
                    >
                      {`${item?.customer_count || 0}`}
                    </Text>
                  )}
                </View>
              </TouchableWithoutFeedback>
            )}
          />
        </View>
        {filteredRoutes.touchpoints?.length === 0 ? (
          <View
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <DbScooter />
            <Text
              variant="body_text_2"
              style={{ color: color.mediumBlacklightBlack, padding: 20 }}
            >
              {isSearchEnabled
                ? t(`${PATH}/noCustomerText`)
                : selectedRouteId === "MISROUTE"
                  ? t(`${PATH}/noMisrouteAssigned`)
                  : selectedRouteId === "UNASSIGN"
                    ? t(`${PATH}/noUnassignedAssigned`)
                    : t(`${PATH}/noCustomerAssigned`)}
            </Text>
          </View>
        ) : (
          <>
            <FlatList
              showsVerticalScrollIndicator={false}
              style={{ height: "100%" }}
              data={filteredRoutes.touchpoints || []}
              keyExtractor={(item, index) =>
                `touchpoint-${cardDraftKey(item) || index}`
              }
              renderItem={({ item, index }) =>
                renderRoute(item, `touchpoint-${cardDraftKey(item) || index}`)
              }
              ListHeaderComponent={() =>
                selectedRouteId !== "ALL" &&
                selectedRouteId !== "UNASSIGN" &&
                selectedRouteId !== "MISROUTE" &&
                filteredRoutes.touchpoints?.length !== 0 ? (
                  <View style={styles.switchDbContainer}>
                    <TouchableWithoutFeedback onPress={onPressExpandSwitchDb}>
                      <View style={styles.switchDbRow}>
                        <Text
                          variant="body_text_2"
                          style={{ color: "rgba(228, 0, 0, 1)" }}
                        >
                          {t(
                            isMultiTripCp(filteredRoutes?.touchpoints)
                              ? `${PATH}/dbTransferMultiTrip`
                              : `${PATH}/dbTransfer`,
                          )}
                        </Text>
                        <View
                          style={{
                            height: 24,
                            width: 24,
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <DownArrowSmall />
                        </View>
                      </View>
                    </TouchableWithoutFeedback>
                    {expandedState ? (
                      <View style={styles.switchDbPills}>
                        {filteredRoutes?.dbs_to_switch?.map((item, index) =>
                          item?.id === "UNASSIGN" &&
                          !isRouteHasDb(selectedRouteId) ? null : (
                            <TouchableWithoutFeedback
                              key={`db-switch-${item.id || index}`}
                              onPress={() => onPressSwitchDb(item.id)}
                            >
                              <View style={styles.notSelectedPill}>
                                <Text
                                  numberOfLines={1}
                                  variant="body_text_3"
                                  style={styles.notSelectedText}
                                >
                                  {item?.db_name || ""}
                                </Text>
                              </View>
                            </TouchableWithoutFeedback>
                          ),
                        ) || null}
                      </View>
                    ) : (
                      <View style={{ height: 0 }} />
                    )}
                  </View>
                ) : null
              }
              initialNumToRender={10}
              maxToRenderPerBatch={10}
              windowSize={10}
              removeClippedSubviews={true}
              onEndReachedThreshold={0.5}
            />
            <View
              style={{
                padding: 10,
                backgroundColor: "#fff",
                elevation: 10,
              }}
            >
              <Button
                btnText={
                  Object.keys(draftRoutes).length === 0
                    ? t(`${PATH}/buttonText`)
                    : `${t(`${PATH}/buttonText`)} ` +
                      `(${Object.keys(draftRoutes).length})`
                }
                onPress={onPressAssignCpTpsBulk}
                buttonWidth="100%"
                buttonColor={color.plain_green}
                buttonStyle={{ borderRadius: 10 }}
                disabled={
                  Object.keys(draftRoutes).length === 0 ||
                  isProcessingRef.current
                }
              />
            </View>
            <SwitchDbConfirmationModal
              visible={showSwitchDbConfirmModal}
              dbs={filteredRoutes.dbs_to_switch}
              selectedDbId={selectedRouteId}
              switchDbId={switchDbId}
              isMultiTrip={isMultiTripCp(filteredRoutes?.touchpoints)}
              onCloseSwitchDbModal={onCloseSwitchDbModal}
              transferAllDeliveries={transferAllDeliveries}
            />
          </>
        )}
        <Modal visible={loading} transparent>
          <View
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
            }}
          >
            <ActivityIndicator size="large" color={color.primary} />
          </View>
        </Modal>
        <UpdateAppModal forceVisible={isUpdateAppRequired} />
      </>
    </>
  );
};

const getPillStyles = ({ routeData, draftRoutes, item }) => {
  const { route_id } = routeData;
  const isDraftPill =
    (draftRoutes[cardDraftKey(routeData)] &&
      draftRoutes[cardDraftKey(routeData)].route_id === item.route_id) ||
    false;
  const isDraftMisRoutePill =
    (draftRoutes[cardDraftKey(routeData)] &&
      draftRoutes[cardDraftKey(routeData)].route_id === "MISROUTE") ||
    false;
  // Locked trip card (owner, 2026-09-04): chips stay READABLE, not hidden, so
  // the leader can still see which route the trip is on. The selected chip
  // keeps its selected shape and is merely greyed, which is what distinguishes
  // "locked" from "unselected".
  if (isTripCard(routeData) || isDisabledCard(routeData)) {
    return item.route_id === route_id
      ? [styles.selectedPill, styles.lockedSelectedPill]
      : [styles.notSelectedPill, styles.lockedPill];
  }
  if (item.route_id === route_id && route_id === "MISROUTE")
    return styles.seletedPillMisRoute;
  if (item.route_id === route_id) return styles.selectedPill;
  if (isDraftPill && isDraftMisRoutePill) return styles.draftPillMisRoute;
  if (isDraftPill) return styles.draftPill;
  return styles.notSelectedPill;
};
const getPillTextStyles = ({ routeData, draftRoutes, item }) => {
  const { route_id } = routeData;
  const isDraftPill =
    (draftRoutes[cardDraftKey(routeData)] &&
      draftRoutes[cardDraftKey(routeData)].route_id === item.route_id) ||
    false;
  const isDraftMisRoutePill =
    (draftRoutes[cardDraftKey(routeData)] &&
      draftRoutes[cardDraftKey(routeData)].route_id === "MISROUTE") ||
    false;
  if (isTripCard(routeData) || isDisabledCard(routeData)) {
    return item.route_id === route_id
      ? [styles.selectedText, styles.lockedSelectedText]
      : [styles.notSelectedText, styles.lockedText];
  }
  if (item.route_id === route_id) return styles.selectedText;
  if (isDraftPill && isDraftMisRoutePill)
    return styles.draftSelectedTextMisRoute;
  if (isDraftPill) return styles.draftSelectedText;
  return styles.notSelectedText;
};

// Exported ONLY so __tests__/routeLockedHint.test.js can render the real JSX
// instead of a replica of it. Nothing else imports it; the screen still uses
// the local binding below.
export const RouteContainer = memo(
  ({
    routeData,
    activeRoutes,
    draftRoutes,
    onPressRoutePill,
    callCustomer,
  }) => {
    const isDraft = !!draftRoutes[cardDraftKey(routeData)];
    // Finished work (owner, 2026-09-21): a greyed card, listed last by the
    // backend, and no escalation/priority highlight since nothing is left to do.
    const isDisabled = isDisabledCard(routeData);
    const isHighlighted =
      !isDisabled && (routeData?.is_escalated || routeData?.is_priority_cx);
    const routeStyle = [
      isDisabled
        ? styles.disabledRouteContainer
        : isDraft
          ? styles.draftRouteContainer
          : styles.routeContainer,
      isHighlighted && { borderWidth: 1, borderColor: "rgba(66, 116, 234, 1)" },
    ];
    // B-5 — trip label, same format and same tag treatment as the OFD page.
    const tripLabel = tripCardLabel(routeData);

    const stageUnassign = () =>
      onPressRoutePill({ routeId: "UNASSIGN", routeData, force: true });

    // B-7 (owner, 2026-09-04): "for only route assignment, confirm dialog might
    // not be necessary. but for ofd'ed rows, if we want to click unassign, i
    // think confirm dialog makes sense." So the dialog is scoped to a TRIP
    // card. Two carve-outs keep it from becoming noise:
    //   - a pending card's Unassign stays silent (plain route work);
    //   - a SECOND tap clears the staged draft (onPressRoutePill toggles on
    //     `existing.route_id === routeId`), and undoing must not ask for
    //     confirmation.
    // Wording follows OutForDeliveryDetails/index.js:217-232; the trailing
    // sentence is this screen's own, because here Unassign only STAGES a draft
    // that the update button submits, it does not call the API.
    const onPressUnassign = () => {
      const staged = draftRoutes[cardDraftKey(routeData)];
      if (staged?.route_id === "UNASSIGN" || !isTripCard(routeData)) {
        return stageUnassign();
      }
      // The dialog copy is translated SERVER-side (citymall-services #28939
      // sends unassign_confirm_title / unassign_confirm_body / unassign_text /
      // unassign_cancel_text already in the leader's language, on TRIP cards —
      // the only kind that reaches this Alert). The English literals are
      // mandatory fallbacks, not padding: they keep this app correct against a
      // backend that predates #28939 and against any field being absent.
      // Do NOT swap them for a client-side i18n lookup — same decided design
      // as route_locked_text below.
      return Alert.alert(
        routeData.unassign_confirm_title || "Unassign this trip?",
        routeData.unassign_confirm_body ||
          "Removes this trip from Out for Delivery but keeps the customer on " +
            "the boy's route so pending orders can still be marked OFD. " +
            "Applied when you submit.",
        [
          {
            text: routeData.unassign_cancel_text || "Cancel",
            style: "cancel",
          },
          {
            text: routeData.unassign_text || "Unassign",
            style: "destructive",
            onPress: stageUnassign,
          },
        ],
      );
    };

    const openMapHandler = (lat, lng) => async () => {
      const url = `google.navigation:q=${lat},${lng}`;
      Linking.canOpenURL(url).then((supported) => {
        if (supported) return Linking.openURL(url);
        else {
          const browser_url = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
          return Linking.openURL(browser_url);
        }
      });
    };

    const result = (
      <View style={routeStyle}>
        {routeData?.delay_text && (
          <Tag text={routeData?.delay_text} bgcolor="rgba(252, 166, 17, 1)" />
        )}
        <View
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            paddingVertical: 4,
            paddingBottom: 8,
          }}
        >
          <View style={{ flexDirection: "row", alignItems: "center" }}>
            <Text
              variant="body_text_2"
              style={{
                maxWidth: Dimensions.get("window").width * 0.6,
              }}
            >
              {routeData.cx_name}
            </Text>
            {tripLabel ? (
              <View style={{ marginLeft: 6 }}>
                <OutlineTag
                  text={tripLabel}
                  bgcolor="#EEF2FF"
                  textColor="#4338CA"
                  borderColor="#4338CA"
                />
              </View>
            ) : null}
            {routeData?.is_escalated ? (
              <View style={{ marginLeft: 6 }}>
                <Tag text="Escalated" bgcolor="rgba(66, 116, 234, 1)" />
              </View>
            ) : null}
            {routeData?.is_priority_cx && (
              <View style={{ marginLeft: 6 }}>
                <Tag text="Priority" bgcolor="rgba(66, 116, 234, 1)" />
              </View>
            )}
          </View>

          <TouchableWithoutFeedback
            onPress={() => callCustomer(routeData.cx_phone_number)}
          >
            <CallIcon strokeColor="#2195F2" width={18} height={18} />
          </TouchableWithoutFeedback>
        </View>

        {/* load_tags — the distinct order_delivered_at times of this customer's
            orders, formatted L-HHMM in IST by the backend
            (getAllOrderTouchpoints -> computeLoadTags). One pill per load time,
            reusing the same Tag component as Priority/delay. The backend always
            sends an array (`[]` when no order is delivered yet), so the row is
            gated on length and simply does not render when empty. */}
        {Array.isArray(routeData?.load_tags) &&
        routeData.load_tags.length > 0 ? (
          <View
            style={{
              flexDirection: "row",
              alignItems: "center",
              flexWrap: "wrap",
              paddingBottom: 8,
            }}
          >
            {routeData.load_tags.map((loadTag) => (
              <View key={loadTag} style={{ marginRight: 6, marginBottom: 4 }}>
                <Tag text={loadTag} bgcolor="#0E9F8E" />
              </View>
            ))}
          </View>
        ) : null}
        <TouchableOpacity
          testID="cpdr-open-map"
          disabled={!(routeData?.cx_lat && routeData?.cx_lng)}
          onPress={openMapHandler(routeData?.cx_lat, routeData?.cx_lng)}
        >
          <Text
            variant="body_text_3"
            style={[
              styles.addressText,
              routeData?.cx_lat &&
                routeData?.cx_lng && {
                  color: "#4274EA",
                  textDecorationLine: "underline",
                },
            ]}
          >
            {routeData.cx_address}
          </Text>
        </TouchableOpacity>

        <RouteList
          routeData={routeData}
          draftRoutes={draftRoutes}
          routesList={activeRoutes}
          onPressRoutePill={onPressRoutePill}
        />

        {/* B-9 — the reason a DISABLED card is not actionable, translated
            server-side (citymall-services #28906 sends `disabled_reason` in the
            leader's language, same contract as route_locked_text above). No
            English fallback literal here, deliberately: unlike the locked hint,
            this line has no pre-#28906 meaning to preserve — a backend that
            does not send it also never sends a `disabled:` card, so there is
            nothing to fall back FOR. The order count comes from the backend's
            own per-card list rather than being counted client-side. */}
        {isDisabledCard(routeData) && (
          <>
            {routeData?.card_order_ids?.length ? (
              <Text variant="body_text_3" style={styles.addressText}>
                {`${routeData.card_order_ids.length} ${
                  routeData.card_order_ids.length === 1 ? "order" : "orders"
                }`}
              </Text>
            ) : null}
            {routeData?.disabled_reason ? (
              <Text variant="body_text_3" style={styles.lockedHintText}>
                {routeData.disabled_reason}
              </Text>
            ) : null}
          </>
        )}

        {/* R-611 — the per-card Unassign. Rendered generically: the BACKEND
            decides enablement (`enable_unassign`) and what the click does
            (the unassign_* hints), the FE only draws it. Same pattern as
            enable_ofd, per DECISIONS-B-14-FE-cards-clarified.md:181 —
            "show Unassign on trip + pending cards, no buttons on disabled".
            A disabled card sends enable_unassign false and gets nothing. */}
        {routeData?.enable_unassign === true && (
          <>
            {isTripCard(routeData) && (
              <Text variant="body_text_3" style={styles.lockedHintText}>
                {/* B3 — the hint is translated SERVER-side (citymall-services
                    #28859 sends `route_locked_text` already in the leader's
                    language). The English literal is a mandatory fallback, not
                    padding: it keeps this app correct against a backend that
                    predates #28859 and against the field ever being absent.
                    Do NOT swap it for a client-side i18n lookup — the decided
                    design is that this string lives in the backend. */}
                {routeData.route_locked_text ||
                  "Route locked — Unassign to change"}
              </Text>
            )}
            <TouchableOpacity
              testID="cpdr-card-unassign"
              style={styles.unassignBtn}
              onPress={onPressUnassign}
            >
              <Text variant="body_text_2" style={styles.unassignText}>
                {/* Translated server-side (#28939) on every card that can draw
                    this button — TRIP and PENDING alike. English literal kept
                    as the mandatory fallback, same rule as the hint above. */}
                {routeData.unassign_text || "Unassign"}
              </Text>
            </TouchableOpacity>
          </>
        )}

        {/* CX_QR_PAYMENT_IN_PROGRESS — a boy is taking a QR payment from this
            customer, so the backend turned Unassign off and says why
            (`unassign_blocked_reason`, translated server-side). Drawn as a
            greyed, inert button with the warning under it rather than
            hidden, so the leader knows the action exists and when it comes
            back. A card staged for Unassign before the QR existed is still
            refused by the API on Submit. */}
        {routeData?.enable_unassign !== true &&
          routeData?.unassign_blocked_reason && (
            <>
              {isTripCard(routeData) && (
                <Text variant="body_text_3" style={styles.lockedHintText}>
                  {routeData.route_locked_text ||
                    "Route locked — Unassign to change"}
                </Text>
              )}
              <View
                testID="cpdr-card-unassign-blocked"
                style={[styles.unassignBtn, styles.unassignBtnDisabled]}
              >
                <Text variant="body_text_2" style={styles.unassignTextDisabled}>
                  {routeData.unassign_text || "Unassign"}
                </Text>
              </View>
              <Text variant="body_text_3" style={styles.unassignBlockedText}>
                {routeData.unassign_blocked_reason}
              </Text>
            </>
          )}
      </View>
    );
    return result;
  },
);

const Tag = ({ text, bgcolor }) => (
  <View
    style={{
      backgroundColor: bgcolor,
      paddingHorizontal: 6,
      paddingVertical: 4,
      borderRadius: 40,
      alignSelf: "flex-start",
      top: -2,
    }}
  >
    {/* R-21 -- fontFamily, never fontWeight. `caption_3` already pins
        `NotoSansDevanagari-Regular`, and on Android RN resolves
        fontFamily + fontWeight by looking for a matching `<family>_bold`
        asset. There is none, so it applies SYNTHETIC bold, which re-shapes
        a Devanagari run and can drop its trailing cluster -- the mechanism
        proven on this screen's Unassign button. This Tag draws
        `routeData.delay_text`, which the backend builds as
        `${delayDays} दिन से लेट`
        (getTouchpoints.js) and is therefore ALWAYS Devanagari. Naming the
        real Bold asset means no synthesis ever happens; the metrics are
        unchanged because only the typeface is being resolved differently. */}
    <Text
      variant="caption_3"
      style={{ color: "#fff", fontFamily: fontFamily.bold }}
    >
      {text}
    </Text>
  </View>
);

const RouteList = memo(
  ({ routeData, draftRoutes, routesList, onPressRoutePill }) => {
    const result = (
      <FlatList
        horizontal
        showsHorizontalScrollIndicator={false}
        style={styles.dbListContainer}
        data={[1]}
        keyExtractor={() => "route-list"}
        renderItem={() => (
          <View style={{ flexDirection: "column" }}>
            {/* The two-row split is driven by the UNFILTERED route count, so a
                locked trip card — which now renders exactly one chip (B-2/B-4)
                — must not take this branch, or it would emit two empty rows. */}
            {routesList?.length > 6 &&
            !isTripCard(routeData) &&
            !isDisabledCard(routeData) ? (
              <>
                <View style={{ flexDirection: "row" }}>
                  {getRouteListSorted(routesList, routeData, 1).map(
                    (item, index) => {
                      const pillStyle = getPillStyles({
                        routeData,
                        draftRoutes,
                        item,
                      });
                      const pillTextStyle = getPillTextStyles({
                        routeData,
                        draftRoutes,
                        item,
                      });
                      return (
                        <TouchableWithoutFeedback
                          key={`route-top-${item.route_id}-${index}`}
                          onPress={() =>
                            onPressRoutePill({
                              routeId: item.route_id,
                              routeData,
                            })
                          }
                        >
                          <View key={index} style={pillStyle}>
                            <Text variant="body_text_3" style={pillTextStyle}>
                              {item.route_name}
                            </Text>
                          </View>
                        </TouchableWithoutFeedback>
                      );
                    },
                  )}
                </View>
                <View style={{ flexDirection: "row" }}>
                  {getRouteListSorted(routesList, routeData, 2).map(
                    (item, index) => {
                      const pillStyle = getPillStyles({
                        routeData,
                        draftRoutes,
                        item,
                      });
                      const pillTextStyle = getPillTextStyles({
                        routeData,
                        draftRoutes,
                        item,
                      });
                      return (
                        <TouchableWithoutFeedback
                          key={`route-bottom-${item.route_id}-${index}`}
                          onPress={() =>
                            onPressRoutePill({
                              routeId: item.route_id,
                              routeData,
                            })
                          }
                        >
                          <View key={index} style={pillStyle}>
                            <Text variant="body_text_3" style={pillTextStyle}>
                              {item.route_name}
                            </Text>
                          </View>
                        </TouchableWithoutFeedback>
                      );
                    },
                  )}
                </View>
              </>
            ) : (
              <View style={{ flexDirection: "row" }}>
                {getRouteListSorted(routesList, routeData, 1).map(
                  (item, index) => {
                    const pillStyle = getPillStyles({
                      routeData,
                      draftRoutes,
                      item,
                    });
                    const pillTextStyle = getPillTextStyles({
                      routeData,
                      draftRoutes,
                      item,
                    });
                    return (
                      <TouchableWithoutFeedback
                        key={`pill-single-${item.route_id}-${index}`}
                        onPress={() =>
                          onPressRoutePill({
                            routeId: item.route_id,
                            routeData,
                          })
                        }
                      >
                        <View style={pillStyle}>
                          <Text variant="body_text_3" style={pillTextStyle}>
                            {item.route_name}
                          </Text>
                        </View>
                      </TouchableWithoutFeedback>
                    );
                  },
                )}
              </View>
            )}
            <View style={{ flexDirection: "row" }}>
              {getRouteListSorted(routesList, routeData, 3).map(
                (item, index) => {
                  const pillStyle = getPillStyles({
                    routeData,
                    draftRoutes,
                    item,
                  });
                  const pillTextStyle = getPillTextStyles({
                    routeData,
                    draftRoutes,
                    item,
                  });
                  return (
                    <TouchableWithoutFeedback
                      key={`pill-extra-${item.route_id}-${index}`}
                      onPress={() =>
                        onPressRoutePill({ routeId: item.route_id, routeData })
                      }
                    >
                      <View style={pillStyle}>
                        <Text variant="body_text_3" style={pillTextStyle}>
                          {item.route_name}
                        </Text>
                      </View>
                    </TouchableWithoutFeedback>
                  );
                },
              )}
            </View>
          </View>
        )}
      />
    );
    return result;
  },
);

const TabButton = ({ title, isActive, onPress }) => {
  return (
    <TouchableOpacity
      testID="sd-sorting-tab-button"
      activeOpacity={0.8}
      style={{
        flex: 1,
        alignItems: "center",
        borderBottomWidth: 4,
        borderBottomColor: isActive ? color.primary : "white",
        paddingVertical: 6,
      }}
      onPress={onPress}
    >
      <Text
        variant="title_16"
        style={{
          paddingVertical: 6,
          color: isActive ? color.black : color.mediumBlacklightBlack,
        }}
      >
        {title}
      </Text>
    </TouchableOpacity>
  );
};

const commonStyles = StyleSheet.create({
  filter: {
    marginVertical: 8,
    marginLeft: 4,
    marginRight: 4,
    padding: 6,
    paddingHorizontal: 12,
    borderRadius: 6,
    elevation: 2,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  pill: {
    flexWrap: "wrap",
    marginTop: 6,
    marginRight: 8,
    padding: 4,
    paddingHorizontal: 18,
    borderRadius: 24,
    overflow: "hidden",
  },
  route: {
    margin: 16,
    marginTop: 0,
    padding: 12,
    paddingHorizontal: 16,
    borderRadius: 12,
    shadowOffset: {
      width: 0,
      height: 1,
    },
    shadowOpacity: 0.2,
    shadowRadius: 1.41,
    elevation: 2,
  },
});

const styles = StyleSheet.create({
  filtersContainer: {
    marginTop: 4,
    flexDirection: "row",
    marginRight: 16,
  },
  filter: {
    ...commonStyles.filter,
    backgroundColor: "#fff",
  },
  selectedFilter: {
    ...commonStyles.filter,
    backgroundColor: "rgba(0, 0, 0, 0.86)",
  },
  routeContainer: {
    ...commonStyles.route,
    backgroundColor: "#fff",
    shadowColor: "#000",
  },
  draftRouteContainer: {
    ...commonStyles.route,
    borderWidth: 1,
    borderColor: "rgba(43, 159, 55, 0.2)",
    backgroundColor: "rgba(0, 171, 89, 0.05)",
    shadowColor: "#fff",
  },
  disabledRouteContainer: {
    ...commonStyles.route,
    borderWidth: 1,
    borderColor: "#E5E7EB",
    backgroundColor: "#F3F4F6",
    shadowColor: "#fff",
    elevation: 0,
    opacity: 0.6,
  },
  dbListContainer: {
    flexDirection: "row",
    marginBottom: 8,
  },
  notSelectedPill: {
    ...commonStyles.pill,
    backgroundColor: "white",
    borderWidth: 1,
    borderColor: "#e4e4e4",
  },
  // R-610 locked chips (owner, 2026-09-04): greyed but STILL READABLE, never
  // hidden -- the leader must be able to see which route the trip is on. Only
  // opacity/colour changes; the pill keeps its size so the row does not reflow
  // between a pending and a trip card for the same customer.
  lockedPill: {
    backgroundColor: "#f4f4f4",
    borderColor: "#dcdcdc",
    opacity: 0.75,
  },
  lockedSelectedPill: {
    backgroundColor: "#9AA79C",
    opacity: 0.9,
  },
  lockedText: {
    color: "#6b6b6b",
  },
  lockedSelectedText: {
    color: "white",
  },
  unassignBtn: {
    alignSelf: "flex-start",
    marginTop: 8,
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: "#C62828",
    backgroundColor: "white",
  },
  // R-11 (2026-09-09): NO `fontWeight` here on purpose. `body_text_3` already
  // pins a concrete font asset (`NotoSansDevanagari-Regular`), and on Android
  // RN resolves `fontFamily` + `fontWeight` by looking for a matching asset
  // ("...-Regular_bold") -- which does not exist -- and falls back to synthetic
  // bold over the regular face. Synthetic bold re-shapes Devanagari badly: the
  // measured line stayed full width (the Text node laid out 222px for
  // "अनअसाइन करें") but the trailing cluster "करें" was never painted, leaving
  // 31dp of blank space inside the button. The control is in the same
  // screenshot: `lockedHintText` below renders the identical word in full with
  // the same variant and NO fontWeight. Bold now comes from `body_text_2`,
  // which maps to the real `NotoSansDevanagari-Bold` asset, so no synthetic
  // bold is ever applied. Do not re-add `fontWeight` to a Devanagari-bearing
  // style -- change the variant instead.
  unassignText: {
    color: "#C62828",
  },
  lockedHintText: {
    color: "#6b6b6b",
    marginTop: 6,
  },
  unassignBtnDisabled: {
    borderColor: "#BDBDBD",
    backgroundColor: "#F3F4F6",
  },
  unassignTextDisabled: {
    color: "#9E9E9E",
  },
  unassignBlockedText: {
    color: "#8A5300",
    backgroundColor: "#FFF7E6",
    marginTop: 8,
    padding: 8,
    borderRadius: 4,
  },
  selectedPill: {
    ...commonStyles.pill,
    backgroundColor: "#2B9F37",
  },
  seletedPillMisRoute: {
    ...commonStyles.pill,
    backgroundColor: color.primary,
  },
  draftPill: {
    ...commonStyles.pill,
    borderWidth: 0.5,
    borderColor: "rgba(43, 159, 55, 0.2)",
    backgroundColor: "rgba(43, 159, 55, 0.2)",
  },
  draftPillMisRoute: {
    ...commonStyles.pill,
    borderWidth: 0.5,
    borderColor: "rgba(228, 0, 70, 0.1)",
    backgroundColor: "rgba(228, 0, 70, 0.1)",
  },
  notSelectedText: {
    color: "black",
  },
  // R-21 -- these three carry a route pill's label, rendered through
  // `variant="body_text_3"`, which pins `NotoSansDevanagari-Regular`. Layering
  // `fontWeight: "700"` on top made Android RN hunt for a `<family>_bold` asset,
  // find none, and apply SYNTHETIC bold -- which re-shapes a Devanagari run and
  // can drop its trailing cluster. That is the same mechanism, in the same file,
  // that swallowed the Unassign button's trailing "करें".
  //
  // Route names are leader-entered free text: production `cp_db_routes_v2`
  // holds 60 Devanagari names out of 38,763 (control: 38,251 Latin), e.g.
  // "अंबेडकर नगर", "गोविंद नगर". Rare, but the ones that exist are the boy's
  // route labels.
  //
  // Naming the real Bold asset is exactly what `body_text_2` does -- it and
  // `body_text_3` differ ONLY in fontFamily (both fontSize.sm, lineHeight 20,
  // see utils/styles/fonts.js) -- so the geometry is unchanged and only the
  // typeface resolves differently. The variant cannot simply be swapped here
  // the way it was on the Unassign button, because these styles are chosen per
  // pill STATE by getPillTextStyles while the variant is fixed on the Text.
  //
  // Do NOT re-add `fontWeight` to a Devanagari-bearing style.
  selectedText: {
    color: "white",
    fontFamily: fontFamily.bold,
  },
  draftSelectedText: {
    color: color.darkGreen,
    fontFamily: fontFamily.bold,
  },
  draftSelectedTextMisRoute: {
    color: color.primary,
    fontFamily: fontFamily.bold,
  },
  addressText: {
    marginBottom: 12,
    color: color.mediumBlacklightBlack,
  },
  switchDbContainer: {
    margin: 16,
    marginVertical: 4,
    marginBottom: 12,
    borderRadius: 12,
    backgroundColor: "#fff",
    borderWidth: StyleSheet.hairlineWidth,
    borderColor: "#e4e4e4",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  switchDbRow: {
    padding: 16,
    paddingVertical: 12,

    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  switchDbPills: {
    paddingTop: 0,
    top: -6,
    padding: 12,
    flexDirection: "row",
    flexWrap: "wrap",
  },
});

export default CpDeliveryRoutes;
